import { apiSlice } from '../../api/apiSlice';

export const assignApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    assignStudents: builder.mutation({
      query: (options) => ({
        url: 'Assignment/AssignStudents',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    getParentFolders: builder.mutation({
      query: () => ({
        url: 'Folder/GetParentFolders',
        method: 'GET',
        credentials: 'include'
      })
    }),
    exportXmlAssignments: builder.mutation({
      query: (options) => ({
        url: 'Assignment/ExportAssignmentToXml',
        method: 'POST',
        credentials: 'include',
        body: options,
        responseHandler: (response) => response.blob(),
      }),
      extraOptions: { showGlobalError: true }
    }),
    getAssignmentShareUsers: builder.mutation({
      query: (options) => ({
        url: 'Student/GetAssignmentShareUsers',
        method: 'GET',
        credentials: 'include',
        params: {
          searchString: options.searchText
        }
      })
    }),
    shareAssignments: builder.mutation({
      query: (options) => ({
        url: 'Assignment/ShareAssignments',
        method: 'POST',
        credentials: 'include',
        body: options
      }),
      extraOptions: { showGlobalError: true }
    }),
    checkIsSelfAssigned: builder.mutation({
      query: (options) => ({
        url: 'Assignment/CheckIsSelfAssigned',
        method: 'POST',
        credentials: 'include',
        body: options.assignmentIds
      }),
      extraOptions: { showGlobalError: true }
    }),
    validateAssignmentName: builder.mutation({
      query: (options) => ({
        url: 'Assignment/ValidateAssignmentName',
        method: 'GET',
        credentials: 'include',
        params: {
          assignmentId: options.assignmentId,
          publicAssignmentName: options.publicAssignmentName,
          options: options.options
        }
      })
    }),
    searchMembers: builder.mutation({
      query: (options) => ({
        url: 'Student/SearchMembers',
        method: 'GET',
        credentials: 'include',
        params: {
          searchText: options.searchText
        }
      })
    }),
    validateSubmitAssignment: builder.mutation({
      query: (options) => ({
        url: 'Assignment/ValidateSubmitAssignment',
        method: 'GET',
        credentials: 'include',
        params: {
          assignmentId: options.assignmentId
        }
      })
    }),
    getChangeReport: builder.mutation({
      query: (options) => ({
        url: `Assignment/GetChangeReport/${options.assignmentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getQuestionById: builder.mutation({
      query: (options) => ({
        url: `Question/${options.questionId}/Assignment/${options.assignmentId}/DetailsById`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPrintSettings: builder.mutation({
      query: (options) => ({
        url: 'Assignment/GetPrintSettings',
        method: 'GET',
        credentials: 'include',
        params: {
          assignmentId: options.assignmentId
        }
      })
    }),
    printQuestions: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/PrintQuestions`,
        method: 'GET',
        credentials: 'include',
        params: {
          languageId: options.languageId
        }
      }),
      extraOptions: { showGlobalError: true }
    }),
    getAnswerKey: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/GetAnswerKey`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    showIdentificationFields: builder.mutation({
      query: (options) => ({
        url: `Student/ShowIdentificationFields?show=${options.condition}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    getFerpaStatus: builder.mutation({
      query: () => ({
        url: 'Student/GetFerpaStatus',
        method: 'GET',
        credentials: 'include'
      })
    }),
    createAssignmentLink: builder.mutation({
      query: (assignmentOptions) => ({
        url: 'Assignment/CreateAssignmentLink',
        method: 'POST',
        body: assignmentOptions
      })
    }),
    getAssignmentVocabulary: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Vocabulary`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentIsStarted: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignment}/CheckIsStarted`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    isAssignmentsExist: builder.mutation({
      query: () => ({
        url: 'Assignment/UserHasAssignment',
        method: 'GET',
        credentials: 'include'
      })
    }),
    setFilterCollapse: builder.mutation({
      query: (options) => ({
        url: `Assignment/FiltersCollapseState/?isCollapsed=${options.isCollapsed}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    checkIsCRQuestionExist: builder.mutation({
      query: (params) => ({
        url: `Assignment/CRQuestionExists?${params}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    deleteAssignments: builder.mutation({
      query: (body) => ({
        url: 'Assignment/DeleteAssignments',
        method: 'DELETE',
        credentials: 'include',
        body
      }),
      extraOptions: { showGlobalError: true }
    }),
  })
});

export const {
  useAssignStudentsMutation,
  useGetParentFoldersMutation,
  useExportXmlAssignmentsMutation,
  useGetAssignmentShareUsersMutation,
  useShareAssignmentsMutation,
  useValidateAssignmentNameMutation,
  useGetPrintSettingsMutation,
  usePrintQuestionsMutation,
  useGetAnswerKeyMutation,
  useSearchMembersMutation,
  useValidateSubmitAssignmentMutation,
  useGetChangeReportMutation,
  useGetQuestionByIdMutation,
  useShowIdentificationFieldsMutation,
  useGetFerpaStatusMutation,
  useCreateAssignmentLinkMutation,
  useGetAssignmentVocabularyMutation,
  useGetAssignmentIsStartedMutation,
  useCheckIsSelfAssignedMutation,
  useIsAssignmentsExistMutation,
  useSetFilterCollapseMutation,
  useCheckIsCRQuestionExistMutation,
  useDeleteAssignmentsMutation
} = assignApi;
